module.exports = __webpack_public_path__ + "img/1.9feade09.jpg";